export enum AccountType {
  CLIENT = 'CLIENT',
  ATTORNEY = 'ATTORNEY',
  PROPERTY_MANAGER = 'PROPERTY_MANAGER'
}
